"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpotlightTechnobudz() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="264698" id="spotlight-ai-coding-classes" className="bg-background text-foreground py-20 md:py-32 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-6">
        <h2 id="our-programs" className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-12 text-foreground tracking-tight">
          Our Programs
        </h2>
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-5 relative">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-primary/10 blur-[100px] rounded-3xl pointer-events-none" />
            
            {}
            <div className="relative z-10 rounded-3xl overflow-hidden border border-border/40 shadow-xl shadow-primary/5 bg-card transform transition-transform duration-700 hover:scale-[1.02]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/child_coding_technobudz.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/child_coding_technobudz.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/child_coding_technobudz.png-wvc-sizes" alt="AI & Coding Classes Creative Learning" className="w-full h-auto object-cover" loading="lazy" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/IMG_6754-3-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/IMG_6754-3-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/IMG_6754-3-scaled.png" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/IMG_6754-3-scaled.png" />
            </div>
          </div>

          {}
          <div className="lg:col-span-7 flex flex-col items-start">
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-3 py-1 rounded-lg bg-primary/10 text-primary text-sm font-medium">Our AI Program</span>
              <span className="px-3 py-1 rounded-lg bg-chart-2/10 text-chart-2 text-sm font-medium">Logic & Coding</span>
              <span className="px-3 py-1 rounded-lg bg-chart-3/10 text-chart-3 text-sm font-medium">Creative Learning</span>
            </div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/logo.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/logo.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1682293/img/logo.png-wvc-sizes" alt="TechnoBudz Logo" className="h-16 w-auto mb-0 object-contain" loading="lazy" />
            <p className="font-default text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl leading-relaxed">
              TechnoBudz Australia is our flagship children's technology education initiative. Operated by Future Ready Australia Ltd, the program introduces children to AI, coding, problem-solving and creative technology through fun, hands-on workshops and classes.
              Through TechnoBudz Australia, we aim to make future-ready learning exciting, accessible and confidence-building for young learners.
            </p>
            <Button variant="secondary" size="lg" className="rounded-xl px-8 h-14 text-base font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20" asChild>
              <Link to="https://technobudz.com">
                Visit TechnoBudz Australia
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}